export default __webpack_public_path__ + "static/media/michelle-mannering.58cc361f.png";